import { Component, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatLegacyFormFieldAppearance as MatFormFieldAppearance } from '@angular/material/legacy-form-field';
import { InputTypeInterface } from '../../../interfaces/input-type.interface';
import icVisibility from '@iconify/icons-ic/twotone-visibility';
import icVisibilityOff from '@iconify/icons-ic/twotone-visibility-off';
@Component({
  selector: 'form-number-input',
  templateUrl: './form-number-input.component.html',
})
export class NumberInputComponent {
  @Input() formGroup: UntypedFormGroup;
  @Input() controlName: string;
  @Input() label: string;
  @Input() appearance: MatFormFieldAppearance = 'outline';
  @Input() type: typeof InputTypeInterface = 'text';
  @Input() minNumber: number;
  @Input() maxNumber: number;
  @Input() placeholder = '';
  @Input() hint = '';
  @Input() icon: any;
  @Input() obscure = false;
  @Input() defaultErrorMessage: any;
  @Input() invalidPatternMessage: string;
  @Input() customErrorMessage: string;
  @Input() withoutPadding = false;
  @Input() maxLength: number;
  @Input() minLength: number;
  @Output() onLostFocus = new EventEmitter<void>();

  onInput(event: Event) {
    if (this.maxLength) {
      const input = event.target as HTMLInputElement;
      input.value = input.value.slice(0, this.maxLength);
      this.formGroup.controls[this.controlName].setValue(input.value);
    }
  }

  visible = false;
  icVisibility = icVisibility;
  icVisibilityOff = icVisibilityOff;

  toggleInput() {
    this.visible = !this.visible;
  }
}
